import React, { FC, Fragment } from 'react'
import { useAzureRole, useTargetPerson } from '../../../hooks'
import AzureAdminRoleDrawer from './AzureAdminRoles'
import AzureRbacRoleDrawer from './AzureRbacRoles'

export const AzureRoles: FC<any> = (props) => {
    const [targetPerson] = useTargetPerson()

    const { data, isInitialLoading } = useAzureRole(props.id, targetPerson?.id)

    if (isInitialLoading || !data) {
        return <Fragment />
    }

    if (data.roleGroupType === 'Admin') {
        return <AzureAdminRoleDrawer {...props} />
    } else if (data.roleGroupType === 'Rbac')
        return <AzureRbacRoleDrawer {...props} />

    return <Fragment />
}
